/* eslint-disable */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { CommonDropdown, RegularButton, ICommonDropdownOption, FullScreenLoading } from 'pg-ui-library';
import { DefaultTable } from 'src/components';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import SupportDeskService from 'src/services/support-desk.service';
import {
  useAddSupportTicketReply,
  useUpdateSupportTicketStatus,
  useUpdateSupportTicket,
} from '../mutations/add-update-reply-support-ticket';
import { useFormik } from 'formik';
import { IReply, ISupportDesk } from 'src/interfaces';
import * as yup from 'yup';
import Arrow from 'src/assets/arrow-left-black.svg';
import attachment from 'src/assets/attachment.svg';
import attachmentBlue from 'src/assets/attachment-blue.svg';
import {
  Container,
  ContainerDetail,
  ArrowBack,
  ConversationSection,
  Conversation,
  ConversationEntry,
  SeparatorLineStraight,
  TicketProfile,
  ProfileImage,
  ProfileInitial,
  ProfileDetails,
  Message,
  ReplyArea,
  ReplyHeader,
  ReopenContainer,
  ReplyProfileImage,
  ReplyProfileDetails,
  ReplyTextarea,
  ActionButtonsWrapper,
  FormattingOptions,
  FormattingButton,
  ButtonContainer,
  DiscardButton,
  PostButton,
  TicketDetails,
  TicketDetailsTitle,
  TicketDetailsText,
  RightTicketDetailsText,
  TicketDetailsTextAns,
  HeaderTop,
  RightSideHeader,
  RightTicketDetailsDropdown,
  TicketDetailsEdit,
} from './styles';
import { TicketReopenModal } from '../support-ticket-modal';
import { DateTime } from 'luxon';
import { supportDeskOptions, supportDeskSubmodules } from '../support-dropdown';

export enum Ticket {
  OPEN = 'Open',
  OPEN_value = 'Open',
  IN_PROGRESS = 'In Progress',
  IN_PROGRESS_value = 'In Progress',
  ON_HOLD = 'On Hold',
  ON_HOLD_value = 'On Hold',
  SOLVED = 'Resolved',
  SOLVED_value = 'Resolved',
  CANCELLED = 'Cancelled',
  CANCELLED_value = 'Cancelled',
}

const myticketOptions: ICommonDropdownOption[] = [
  {
    key: '1',
    label: Ticket.OPEN,
    value: Ticket.OPEN_value,
  },
  {
    key: '2',
    label: Ticket.ON_HOLD,
    value: Ticket.ON_HOLD_value,
  },
  {
    key: '3',
    label: Ticket.IN_PROGRESS,
    value: Ticket.IN_PROGRESS_value,
  },
  {
    key: '4',
    label: Ticket.SOLVED,
    value: Ticket.SOLVED_value,
  },
  {
    key: '5',
    label: Ticket.CANCELLED,
    value: Ticket.CANCELLED_value,
  },
];

const customStyles = {
  headRow: {
    style: {
      border: 'none',
    },
  },
  headCells: {
    style: {
      color: '#9399B2',
      font: 'normal normal bold 16px Biotif',
    },
  },
  rows: {
    style: {
      font: 'normal normal normal 14px Biotif',
      color: '#1B1D35',
      borderRadius: '0px',
      '&:not(:last-of-type)': {
        borderBottomWidth: '0px',
      },
    },
    stripedStyle: {
      color: '#1B1D35',
      backgroundColor: '#F3F4F8',
      minHeight: '40px',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(230, 244, 244)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  cells: {
    style: {
      justifyContent: 'left',
      '&:not(:nth-of-type(2))': {
        justifyContent: 'left',
      },
      '&:first-of-type': {
        justifyContent: 'left',
      },
      '&:last-of-type': {
        justifyContent: 'left',
      },
    },
  },
  pagination: {
    style: {
      border: 'none',
      svg: {
        fill: 'rgba(0,0,0,0.54)',
      },
    },
  },
};

const getInitials = (name: string | undefined) => {
  if (!name) return '';
  const nameParts = name.trim().split(' ');
  if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
  return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
};

const ProfilePicture: React.FC<{ src?: string; name?: string }> = ({ src, name }) => {
  if (src) {
    return <ProfileImage src={src} alt="User Profile" />;
  } else {
    const initials = getInitials(name);
    return <ProfileInitial>{initials}</ProfileInitial>;
  }
};

const SupportDeskDetail: React.FC = () => {
  const navigate = useNavigate();

  const replyAddSupport = useAddSupportTicketReply();
  const updateStatusMutation = useUpdateSupportTicketStatus();
  const updateSupportTicket = useUpdateSupportTicket();

  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  const { ticketId } = useParams<{ ticketId: string }>();
  const companyId = '';
  const [statusTicket, setStatusTicket] = useState<string>('');
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { isFetching, data, refetch } = useQuery(['support-desk-reply'], async () => {
    const result = await SupportDeskService.getSupportTicketsReply({
      companyId,
      ticketId,
    });
    return result;
  });

  const handleBackClick = () => {
    navigate('/support-desk');
  };

  const ticketIdShown = data?.supportTicket?.supportNumber;
  const supportTicket = data?.supportTicket;
  const supportTicketDetail = data?.supportTicket as ISupportDesk | undefined;

  const replies = data?.replies || [];

  const bankDetailsData = supportTicket?.isBankRelated === 'Yes' && data?.bankDetails ? data.bankDetails : null;

  const [isEditing, setIsEditing] = useState(false);
  const [editedTicket, setEditedTicket] = useState({
    module: supportTicket?.module,
    subCategory: supportTicket?.subCategory,
    priority: supportTicket?.priority,
  });

  const [submoduleOptions, setSubmoduleOptions] = useState(
    supportTicket?.module ? supportDeskSubmodules[supportTicket.module] : []
  );

  const [priority, setPriority] = useState<string>(supportTicket?.priority || '');
  const [module, setModule] = useState<string>(supportTicket?.module || '');
  const [subCategory, setSubCategory] = useState<string>(supportTicket?.subCategory || '');
  const [subCategoryOptions, setSubCategoryOptions] = useState<ICommonDropdownOption[]>([]);

  useEffect(() => {
    if (supportTicket?.module) {
      setModule(supportTicket.module);
      const newSubcategoryOptions = supportDeskSubmodules[supportTicket.module] || [];
      setSubCategoryOptions(newSubcategoryOptions);
      setSubCategory(supportTicket.subCategory || newSubcategoryOptions[0]?.value || '');
    }
  }, [supportTicket?.module, supportTicket?.subCategory]);

  const handleModuleChange = (value: string) => {
    setModule(value);
    const newSubcategoryOptions = supportDeskSubmodules[value] || [];
    setSubCategoryOptions(newSubcategoryOptions);
    setSubCategory(newSubcategoryOptions[0]?.value || '');
  };

  const handleSave = async () => {
    if (!ticketId) {
      console.error('Ticket ID is required.');
      return;
    }
    const updateData = {
      module,
      subCategory,
      priority,
    };

    try {
      await updateSupportTicket.mutateAsync({
        ticketId,
        updateData,
      });

      refetch();
      setIsEditing(false);
    } catch (error) {
      console.error('Failed to save ticket:', error);
    }
  };

  const handleCancel = () => {
    setModule(supportTicket?.module || '');
    setSubCategory(supportTicket?.subCategory || '');
    setPriority(supportTicket?.priority || '');
    setEditedTicket({
      module: supportTicket?.module,
      subCategory: supportTicket?.subCategory,
      priority: supportTicket?.priority,
    });
    setIsEditing(false);
  };

  const handlePriorityChange = (event: any) => {
    setEditedTicket({ ...editedTicket, priority: event.target.value });
  };

  const handleSubmoduleChange = (event: any) => {
    setEditedTicket({ ...editedTicket, subCategory: event.target.value });
  };

  const attachments = supportTicket?.attachments || [];
  const createdDate = supportTicket?.CreatedTo ? DateTime.fromISO(supportTicket.CreatedTo) : DateTime.now();

  const statusMapping: { [key: string]: { label: string; color: string } } = {
    [Ticket.OPEN_value]: { label: Ticket.OPEN, color: '#E67E22' },
    [Ticket.ON_HOLD_value]: { label: Ticket.ON_HOLD, color: '#F39C12' },
    [Ticket.IN_PROGRESS_value]: { label: Ticket.IN_PROGRESS, color: '#337ECF' },
    [Ticket.SOLVED_value]: { label: Ticket.SOLVED, color: '#6FC38A' },
    [Ticket.CANCELLED_value]: { label: Ticket.CANCELLED, color: '#E74C3C' },
  };

  const getStatusDetails = (status: string) => {
    return statusMapping[status] || { label: status, color: '#BDC3C7' };
  };

  useEffect(() => {
    if (supportTicket) {
      setStatusTicket(supportTicket.status ?? '');
    }
  }, [supportTicket]);

  const validationSchema = yup.object({
    description: yup.string().required('Description is required'),
  });

  const formik = useFormik({
    initialValues: {
      module: '',
      subject: '',
      description: '',
      attachments: [],
    },
    validationSchema,
    onSubmit: async (values: IReply) => {
      if (!ticketId) {
        console.error('Ticket ID is missing');
        return;
      }
      try {
        const formData = new FormData();
        formData.append('module', values.module || '');
        formData.append('subject', values.subject || '');
        formData.append('description', values.description || '');
        formData.append('status', 'open');
        uploadedFiles.forEach(file => {
          formData.append('attachments', file);
        });
        await replyAddSupport.mutateAsync({ ticketId, ticket: formData });
        refetch();
        formik.resetForm();
        setUploadedFiles([]);
      } catch (error) {
        console.error('Error during submission of Ticket', error);
      }
    },
  });

  const fileInputRef = React.useRef<any>(null);
  const handleFileUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current?.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || []);
    setUploadedFiles(prevFiles => [...prevFiles, ...files]);
    formik.setFieldValue('fileUpload', files);
  };

  const handleRemoveFile = (index: number) => {
    const updatedFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(updatedFiles);
    formik.setFieldValue('fileUpload', updatedFiles);
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    } else {
      console.log('fileInputRef.current is null');
    }
  };

  const handleSaveStatus = async () => {
    if (!ticketId || !statusTicket) {
      console.error('Ticket ID or status is missing');
      return;
    }
    try {
      await updateStatusMutation.mutateAsync({ ticketId, status: statusTicket });
      refetch();
    } catch (error) {
      console.error('Error updating status', error);
    }
  };

  const normalizedStatus = supportTicket?.status?.toLowerCase();
  const isClosed = normalizedStatus === 'cancelled' || normalizedStatus === 'solved' || normalizedStatus === 'resolved';

  const HIDDEN_REPLY_STATUSES = [Ticket.CANCELLED_value, Ticket.SOLVED_value];

  return (
    <Container>
      <TicketReopenModal isOpen={isOpen} setIsOpen={setIsOpen} supportTicket={supportTicketDetail} />
      {(replyAddSupport.isLoading || updateSupportTicket.isLoading || updateStatusMutation.isLoading || isFetching) && (
        <FullScreenLoading />
      )}

      <HeaderTop>
        <ArrowBack src={Arrow} onClick={handleBackClick} />
        <h2>Ticket Chat</h2>
        <RightSideHeader>
          <p style={{ minWidth: '70px', marginTop: '25px' }}>Status</p>
          {(supportTicket?.status === 'cancelled' || supportTicket?.status === 'solved') && (
            <CommonDropdown
              label=""
              id="statusTicket"
              name="statusTicket"
              options={myticketOptions}
              value={statusTicket}
              setValue={(value: string) => {
                setStatusTicket(value);
              }}
              selectStyle={{
                width: '200px',
                marginRight: '10px',
                backgroundColor: 'white',
                color: 'black',
                borderRadius: '6px',
              }}
              disabled
            />
          )}
          {!(
            supportTicket?.status === 'cancelled' ||
            supportTicket?.status === 'Cancelled' ||
            supportTicket?.status === 'solved' ||
            supportTicket?.status === 'Solved' ||
            supportTicket?.status === 'resolved' ||
            supportTicket?.status === 'Resolved'
          ) && (
            <CommonDropdown
              label=""
              id="statusTicket"
              name="statusTicket"
              options={myticketOptions}
              value={statusTicket}
              setValue={(value: string) => {
                setStatusTicket(value);
              }}
              selectStyle={{
                width: '200px',
                marginRight: '10px',
                backgroundColor: 'white',
                color: 'black',
                borderRadius: '6px',
                margin: '0.5em',
                fontWeight: '500',
                maxHeight: '36px',
                padding: '8px',
                fontFamily: 'Biotif',
                fontSize: '1.6rem',
              }}
            />
          )}
          {!(
            supportTicket?.status === 'cancelled' ||
            supportTicket?.status === 'Cancelled' ||
            supportTicket?.status === 'solved' ||
            supportTicket?.status === 'Solved' ||
            supportTicket?.status === 'resolved' ||
            supportTicket?.status === 'Resolved'
          ) && (
            <RegularButton onClick={handleSaveStatus} disabled={updateStatusMutation.isLoading}>
              Update
            </RegularButton>
          )}
        </RightSideHeader>
      </HeaderTop>
      <ContainerDetail>
        <ConversationSection>
          <Conversation>
            <h2 style={{ marginLeft: '7px', fontSize: '24px' }}>
              <strong>Ticket ID- #</strong>
              {ticketIdShown}
            </h2>
            <ConversationEntry>
              <TicketProfile>
                <ProfilePicture src={supportTicket?.userProfileUrl ?? undefined} name={supportTicket?.userFirstName} />
                <ProfileDetails>
                  <TicketDetailsText>
                    <span style={{ marginRight: '10px' }}>{supportTicket?.userFirstName}</span>
                    <span style={{ color: '#9399B2' }}>{createdDate.toRelative() || 'Unknown'}</span>
                  </TicketDetailsText>
                </ProfileDetails>
              </TicketProfile>
              <Message>
                <p>{supportTicket?.description}</p>
              </Message>

              <div>
                <p>
                  {attachments && attachments.length > 0 && (
                    <img
                      src={attachmentBlue}
                      alt="Formatting Icon"
                      style={{ height: '17px', margin: '0px 10px 0px 2px' }}
                    />
                  )}
                  {attachments.map((attachment, index) => (
                    <React.Fragment key={index}>
                      <a href={attachment.attachmentUrl} target="_blank" rel="noopener noreferrer">
                        {attachment.attachmentName}
                      </a>
                      {index < attachments.length - 1 && ', '}
                    </React.Fragment>
                  ))}
                </p>
              </div>
              {supportTicket?.isBankRelated === 'Yes' &&
                bankDetailsData &&
                (() => {
                  const { type, newBankInfo, updatedBankInfo, originalBankInfo } = bankDetailsData;

                  const bankDataToDisplay = (() => {
                    if ((type === 'add' || type === 'added') && newBankInfo) {
                      return [
                        {
                          ...newBankInfo,
                          _uniqueKey: `new-${newBankInfo.id}`,
                          isNew: true,
                          actionType: 'added',
                        },
                      ];
                    }

                    if (type === 'updated' && updatedBankInfo && originalBankInfo) {
                      return [
                        {
                          ...originalBankInfo,
                          _uniqueKey: `original-${originalBankInfo.id}`,
                          isOriginal: true,
                          actionType: 'current',
                        },
                        {
                          ...updatedBankInfo,
                          _uniqueKey: `updated-${updatedBankInfo.id}`,
                          isNew: true,
                          actionType: 'updated',
                        },
                      ];
                    }

                    return [];
                  })();

                  return bankDataToDisplay.length > 0 ? (
                    <div style={{ marginTop: '20px' }}>
                      <h4>Bank Account Information</h4>
                      <DefaultTable
                        keyField="_uniqueKey"
                        columns={[
                          { name: 'Account Name', selector: (row: any) => row.name || '', width: '200px' },
                          { name: 'Account Number', selector: (row: any) => row.accountNumber || '', width: '200px' },
                          { name: 'Account ID', selector: (row: any) => row.accountId || '', width: '200px' },
                          { name: 'Account Type', selector: (row: any) => row.type || '', width: '150px' },
                          { name: 'Action Type', selector: (row: any) => row.actionType || '', width: '150px' },
                        ]}
                        data={bankDataToDisplay}
                        customStyles={customStyles}
                        pagination={false}
                        conditionalRowStyles={[
                          {
                            when: (row: any) => row.isNew === true,
                            style: {
                              backgroundColor: '#e8f5e9',
                              color: '#2e7d32',
                              fontWeight: 'bold',
                            },
                          },
                          {
                            when: (row: any) => row.isOriginal === true,
                            style: {
                              backgroundColor: '#fff9c4',
                              color: '#f9a825',
                              fontWeight: 'bold',
                            },
                          },
                        ]}
                      />
                    </div>
                  ) : null;
                })()}
            </ConversationEntry>
            <SeparatorLineStraight />
            {replies.map((reply, index) => (
              <div>
                <ConversationEntry>
                  <TicketProfile>
                    <ProfilePicture src={reply.userProfileUrl ?? undefined} name={reply.userFirstName} />
                    <ProfileDetails>
                      <TicketDetailsText>
                        <span style={{ marginRight: '10px' }}>{reply.userFirstName}</span>
                        <span style={{ color: '#9399B2' }}>
                          {reply.createdAt ? DateTime.fromISO(reply.createdAt).toRelative() || 'Unknown' : 'Unknown'}
                        </span>
                      </TicketDetailsText>
                    </ProfileDetails>
                  </TicketProfile>

                  <Message>
                    <p>
                      {reply?.description?.includes('??')
                        ? (() => {
                            const [rawFirstPart, secondPart] = reply.description.split('??');

                            const cleanedFirstPart = rawFirstPart.replace(/<\/?[^>]+(>|$)/g, '').trim();
                            const cleanedSecondPart = secondPart?.replace(/<\/?[^>]+(>|$)/g, '').trim();

                            return (
                              <>
                                <b>
                                  <i>{cleanedFirstPart}</i>
                                </b>
                                <br />
                                {cleanedSecondPart}
                              </>
                            );
                          })()
                        : reply?.description?.replace(/<\/?[^>]+(>|$)/g, '') ?? ''}
                    </p>
                  </Message>
                  <div>
                    <p>
                      {reply.attachments && reply.attachments.length > 0 && (
                        <img
                          src={attachmentBlue}
                          alt="Formatting Icon"
                          style={{ height: '17px', margin: '0px 10px 0px 2px' }}
                        />
                      )}
                      {reply.attachments &&
                        reply.attachments.length > 0 &&
                        reply.attachments.map((attachment, index) => (
                          <React.Fragment key={index}>
                            <a href={attachment.attachmentUrl} target="_blank" rel="noopener noreferrer">
                              {attachment.attachmentName}
                            </a>
                            {index < (reply.attachments || []).length - 1 && ', '}
                          </React.Fragment>
                        ))}
                    </p>
                  </div>
                </ConversationEntry>

                <SeparatorLineStraight />
              </div>
            ))}
          </Conversation>
          {!isClosed && (
            <ReplyArea>
              <ReplyHeader>
                <ProfilePicture src={supportTicket?.userProfileUrl ?? undefined} name={supportTicket?.userFirstName} />
                <ReplyProfileDetails>
                  <TicketDetailsText>{supportTicket?.userFirstName}</TicketDetailsText>
                </ReplyProfileDetails>
              </ReplyHeader>
              <ReplyTextarea
                placeholder="Enter here..."
                value={formik.values.description}
                onChange={event => formik.setFieldValue('description', event.target.value)}
              />

              <div
                style={{
                  width: '55%',
                  marginTop: '0px',
                  paddingTop: '0px',
                  borderRadius: '7px',
                }}
              >
                {uploadedFiles.map((file, index) => (
                  <div key={index} style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                    <a
                      href={URL.createObjectURL(file)}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: '#4A4BA9',
                        textDecoration: 'none',
                        marginRight: '10px',
                        fontSize: '12px',
                      }}
                    >
                      {file?.name}
                    </a>
                    <span
                      onClick={() => handleRemoveFile(index)}
                      style={{
                        color: '#4A4BA9',
                        cursor: 'pointer',
                        fontSize: '12px',
                      }}
                    >
                      ✕
                    </span>
                  </div>
                ))}
              </div>
              <ButtonContainer>
                <FormattingOptions>
                  <FormattingButton onClick={handleButtonClick} style={{ border: '1px solid #fff' }}>
                    <img src={attachment} alt="Formatting Icon" />
                  </FormattingButton>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    multiple
                    onChange={handleFileChange}
                  />
                </FormattingOptions>
                <ActionButtonsWrapper>
                  <DiscardButton>Discard</DiscardButton>
                  <PostButton onClick={() => formik.handleSubmit()}>Post</PostButton>
                </ActionButtonsWrapper>
              </ButtonContainer>
            </ReplyArea>
          )}

          {/* {!isClosed && ( */}

          {(supportTicket?.status === 'cancelled' ||
            supportTicket?.status === 'Cancelled' ||
            supportTicket?.status === 'solved' ||
            supportTicket?.status === 'Resolved' ||
            supportTicket?.status === 'Solved' ||
            supportTicket?.status === 'resolved') && (
            <ReopenContainer>
              <p>
                The ticket has been {supportTicket?.status === 'cancelled' ? 'Cancelled' : 'Solved'}. If you want, you
                can reopen it.
              </p>
              <DiscardButton
                onClick={() => {
                  setIsOpen(true);
                }}
              >
                Reopen
              </DiscardButton>
            </ReopenContainer>
          )}
        </ConversationSection>
        {!isEditing && (
          <TicketDetails>
            <TicketDetailsTitle>
              Ticket Information
              <div>
                <RegularButton onClick={() => setIsEditing(true)}>Edit</RegularButton>
              </div>
            </TicketDetailsTitle>

            <SeparatorLineStraight />
            <RightTicketDetailsText style={{ fontSize: '18px', color: '#1C1B3A', marginBottom: '12px' }}>
              <strong>
                {' '}
                {supportTicket?.userFirsName} {supportTicket?.userLastName} Submitted this Request
              </strong>
            </RightTicketDetailsText>
            <RightTicketDetailsText>
              <strong>Module:</strong>
            </RightTicketDetailsText>
            <TicketDetailsTextAns>
              {(() => {
                const module = supportTicket?.module.toLowerCase();
                let label = '';
                if (module === 'hrprofile' || module === 'hr_profile') {
                  label = 'Profile';
                } else if (module === 'benefits') {
                  label = 'Benefits';
                } else if (module === 'pay_history' || module === 'payroll') {
                  label = 'Payroll';
                } else if (module === 'tax' || module === 'tax_forms') {
                  label = 'Tax';
                } else {
                  label = supportTicket?.module || '';
                }
                return label;
              })()}
            </TicketDetailsTextAns>

            <RightTicketDetailsText>
              <strong>Sub Category:</strong>
            </RightTicketDetailsText>
            <TicketDetailsTextAns>{supportTicket?.subCategory}</TicketDetailsTextAns>
            <RightTicketDetailsText>
              <strong>Description:</strong>
            </RightTicketDetailsText>
            <TicketDetailsTextAns>{supportTicket?.description}</TicketDetailsTextAns>
            <RightTicketDetailsText>
              <strong>Priority:</strong>
            </RightTicketDetailsText>
            <TicketDetailsTextAns>{supportTicket?.priority}</TicketDetailsTextAns>
            <RightTicketDetailsText>
              <strong>Attachments:</strong>{' '}
            </RightTicketDetailsText>
            {attachments.length > 0 && (
              <TicketDetailsTextAns>
                <img
                  src={attachmentBlue}
                  alt="Formatting Icon"
                  style={{ height: '18px', margin: '0px 10px 0px 2px' }}
                />
                {attachments.map((attachment, index) => (
                  <React.Fragment key={index}>
                    <a href={attachment.attachmentUrl} target="_blank" rel="noopener noreferrer">
                      {attachment.attachmentName}
                    </a>
                    {index < attachments.length - 1 && ', '}
                  </React.Fragment>
                ))}
              </TicketDetailsTextAns>
            )}
            <RightTicketDetailsText>
              <strong>Assignee:</strong>
            </RightTicketDetailsText>
            {supportTicket?.assignId !== null && (
              <TicketDetailsTextAns>
                {supportTicket?.userAssignFirstName} {supportTicket?.userAssignLastName}
              </TicketDetailsTextAns>
            )}
            <RightTicketDetailsText>
              <strong>Status:</strong>
            </RightTicketDetailsText>
            <TicketDetailsTextAns>
              <RegularButton
                style={{
                  margin: '2px 0px 2px 0px',
                  backgroundColor: getStatusDetails(supportTicket?.status ?? '').color,
                  color: 'white',
                  border: 'none',
                  padding: '5px 10px',
                  borderRadius: '4px',
                }}
              >
                {getStatusDetails(supportTicket?.status ?? '').label}
              </RegularButton>
            </TicketDetailsTextAns>
            <RightTicketDetailsText>
              <strong>Created:</strong>
            </RightTicketDetailsText>
            <TicketDetailsTextAns>{createdDate.toRelative() || 'Unknown'}</TicketDetailsTextAns>
            <RightTicketDetailsText>
              <strong>User Name:</strong>
            </RightTicketDetailsText>
            <TicketDetailsTextAns>{supportTicket?.username}</TicketDetailsTextAns>
            <RightTicketDetailsText>
              <strong>Full Name:</strong>
            </RightTicketDetailsText>
            <TicketDetailsTextAns>
              {`${supportTicket?.userFirsName} ${
                supportTicket?.userMiddleName ? supportTicket?.userMiddleName + ' ' : ''
              }${supportTicket?.userLastName}`}
            </TicketDetailsTextAns>

            <RightTicketDetailsText>
              <strong>Employee Id:</strong>
            </RightTicketDetailsText>
            <TicketDetailsTextAns>{supportTicket?.employeeNickId}</TicketDetailsTextAns>
          </TicketDetails>
        )}
        {isEditing && (
          <TicketDetailsEdit>
            <TicketDetailsTitle>Ticket Edit</TicketDetailsTitle>

            <SeparatorLineStraight />

            <RightTicketDetailsText>
              <strong>Please select the Module:</strong>
            </RightTicketDetailsText>
            <RightTicketDetailsDropdown>
              <CommonDropdown
                label=""
                id="module"
                name="module"
                options={supportDeskOptions}
                value={module}
                setValue={handleModuleChange}
                selectStyle={{
                  width: '100%',
                  height: '35px',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                }}
              />
            </RightTicketDetailsDropdown>

            <RightTicketDetailsText>
              <strong>Sub Category:</strong>
            </RightTicketDetailsText>
            <RightTicketDetailsDropdown>
              <CommonDropdown
                label=""
                id="subCategory"
                name="subCategory"
                options={subCategoryOptions}
                value={subCategory}
                setValue={(value: string) => setSubCategory(value)}
                selectStyle={{
                  width: '100%',
                  height: '35px',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                }}
              />
            </RightTicketDetailsDropdown>

            <RightTicketDetailsText>
              <strong>Level of Priority</strong>
            </RightTicketDetailsText>
            <RightTicketDetailsDropdown>
              <CommonDropdown
                label=""
                id="priority"
                name="priority"
                options={['Low', 'Normal', 'High', 'Urgent'].map((level, index) => ({
                  key: `${index}`,
                  label: level,
                  value: level,
                }))}
                value={priority}
                setValue={(value: string) => setPriority(value)}
                selectStyle={{
                  width: '100%',
                  height: '35px',
                  borderRadius: '7px',
                  border: '1px solid #ccc',
                }}
              />
            </RightTicketDetailsDropdown>

            <div style={{ marginTop: 'auto', display: 'flex', gap: '10px' }}>
              <RegularButton onClick={handleSave} style={{ backgroundColor: 'green', color: 'white' }}>
                Save
              </RegularButton>
              <RegularButton onClick={handleCancel} style={{ backgroundColor: 'red', color: 'white' }}>
                Cancel
              </RegularButton>
            </div>
          </TicketDetailsEdit>
        )}
      </ContainerDetail>
    </Container>
  );
};

export default SupportDeskDetail;
